import { Box, styled } from "@mui/material";

import { COLORS, TYPOGRAPHY } from "../../CreationModal.constants";

export const Wrap = styled(Box)({
    display: "flex",
    alignItems: "center",
    gap: 16,
});

export const Text = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
});

export const Title = styled("h3")({
    margin: 0,
    color: COLORS.slate900,
    ...TYPOGRAPHY.title,
});

export const Description = styled("p")({
    margin: 0,
    color: COLORS.slate500,
    ...TYPOGRAPHY.bodySm,
    fontSize: "13px",
});
